import Vue from "vue";
import MlButton from "@/components/MlButton";
import MlPopup from "@/components/MlPopup";
import MlHeader from "@/components/MlHeader";
import MlSearchBar from "@/components/MlSearchBar";
import MlLoading from "@/components/MlLoading";

// 自定义组件注册
Vue.component("ml-button", MlButton);
Vue.component("ml-popup", MlPopup);
Vue.component("ml-header", MlHeader);
Vue.component("ml-search-bar", MlSearchBar);
Vue.component("ml-loading", MlLoading);
